import React from 'react';
import { useSurvey } from '../../../context/SurveyContext';
import { FileText, Trash2, BarChart3 } from 'lucide-react';

const SurveyList = ({ onSelectSurvey }) => {
  const { surveys, loadSurvey, deleteSurvey, setResultsMode } = useSurvey();

  const handleSelect = (surveyId) => {
    loadSurvey(surveyId);
    onSelectSurvey();
  };

  const handleDelete = (e, surveyId) => {
    e.stopPropagation();
    if (window.confirm('Delete this survey and all its responses?')) {
      deleteSurvey(surveyId);
    }
  };

  const handleViewResults = (e, surveyId) => {
    e.stopPropagation();
    loadSurvey(surveyId);
    setResultsMode(true);
    onSelectSurvey();
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  if (surveys.length === 0) {
    return (
      <div className="survey-list">
        <div className="survey-list-header">
          <h3>Your Questionnaire Surveys</h3>
        </div>
        <div className="survey-list-empty">
          <FileText size={48} />
          <p>No surveys yet. Create your first survey to get started!</p>
        </div>
      </div>
    );
  }

  return (
    <div className="survey-list">
      <div className="survey-list-header">
        <h3>Your Questionnaire Surveys ({surveys.length})</h3>
      </div>
      <div className="survey-list-items">
        {surveys.map(survey => (
          <div 
            key={survey.id} 
            className="survey-list-item"
            onClick={() => handleSelect(survey.id)}
          >
            <div className="survey-item-info">
              <div className="survey-item-title">{survey.title}</div>
              <div className="survey-item-meta">
                <span>{survey.questions?.length || 0} questions</span>
                <span>{survey.responses?.length || 0} responses</span>
                <span>Updated {formatDate(survey.updatedAt)}</span>
              </div>
            </div>
            <div className="survey-item-actions">
              <span className={`survey-status ${survey.status}`}>
                {survey.status}
              </span>
              {survey.responses?.length > 0 && (
                <button 
                  className="btn-icon"
                  onClick={(e) => handleViewResults(e, survey.id)}
                  title="View Results"
                >
                  <BarChart3 size={18} />
                </button>
              )}
              <button 
                className="btn-icon danger"
                onClick={(e) => handleDelete(e, survey.id)}
                title="Delete Survey"
              >
                <Trash2 size={18} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SurveyList;
